// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"e0adbcf1","113":"b9afb9b2","137":"1cfa52f0","186":"215c9329","383":"9f6635cd","432":"32dda1d1","748":"e4a73c89"}[chunkId] + ".chunk.js";
};